import React, { useState } from 'react';
import { HeaderButtons } from './buttons/HeaderButtons';
import { HelpAndAboutModal } from '../modals/helpAndAboutModal/Modal';
import { SessionTimeModal } from '../modals/sessionTime/Modal';
import type { FunctionComponent } from 'react';
import type { GenericModalProps } from '../modals/ModalLayout';
import {
  useOptionalSurgerySpecificUiConfigValue,
  useSurgerySpecificUiConfigValue
} from '@/engine/app/modules/ui/useUiConfigValue';
import { ModalState } from './types';
import { useInjection } from 'inversify-react';
import { TYPES } from '@/engine/ioc/types';
import type { AppController } from '@/engine/app/App.controller';

export const HeaderCenterContent: React.FC = () => {
  const [modal, setModal] = React.useState<ModalState>(ModalState.None);
  const [sessionTimeButtonDisabled, setSessionTimeButtonDisabled] = useState(false);

  const appController = useInjection<AppController>(TYPES.AppController);
  const caseState = appController.getCaseState();

  const extraHeaderButtons = useSurgerySpecificUiConfigValue<Array<FunctionComponent>>('extraHeaderButtons', []);
  const hasApprovalFunctionality = useSurgerySpecificUiConfigValue<boolean>('hasApprovalFunctionality');
  const UserPreferencesModal =
    useOptionalSurgerySpecificUiConfigValue<FunctionComponent<GenericModalProps>>('userPreferences.component');
  const isUserPreferencesAvailable = UserPreferencesModal !== undefined;

  const modalStateChangeHandler = (modal: ModalState): void => {
    setModal(modal);
  };

  return (
    <>
      <HeaderButtons
        extraHeaderButtons={extraHeaderButtons}
        modalStateChangeHandler={modalStateChangeHandler}
        userPermissions={caseState.userPermissions}
        caseDetailsUrl={caseState.caseDetailsUrl}
        isCineloopActive={appController.isCineloopActive}
        isUserPreferencesAvailable={isUserPreferencesAvailable}
        hasApprovalFunctionality={hasApprovalFunctionality}
        sessionTimeButtonDisabled={sessionTimeButtonDisabled}
      />
      <HelpAndAboutModal isVisible={modal === ModalState.Help} modalStateChangeHandler={modalStateChangeHandler} />
      {isUserPreferencesAvailable && (
        <UserPreferencesModal
          isVisible={modal === ModalState.UserPreferences}
          modalStateChangeHandler={modalStateChangeHandler}
        />
      )}
      <SessionTimeModal
        isVisible={modal === ModalState.SessionTime}
        modalStateChangeHandler={modalStateChangeHandler}
        setSessionTimeButtonDisabled={setSessionTimeButtonDisabled}
      />
    </>
  );
};
